import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

let styles;
const BACKGROUND_ASSET = require('./background.png');

export default () => (
  <div className={css(styles.container)}>
    <h1 className={css(styles.title)}>Our Story</h1>
  </div>
);

styles = StyleSheet.create({
  container: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 515,
    marginTop: 80,
    backgroundImage: `url('${BACKGROUND_ASSET}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',

    [Theme.mobile_query]: {
      height: 'auto',
      padding: '80px 20px',
      backgroundPosition: 'left center',
      boxShadow: '0 0 0 1000px rgba(0,0,0,.3) inset',
    },
  },
  title: {
    fontFamily: Theme.font_family_heading,
    fontSize: 100,
    fontWeight: Theme.font_weight_heading,
    color: Theme.white,

    [Theme.mobile_query]: {
      fontSize: 45,
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/AboutHero/index.js